export default {
  channel_feed_title: 'Feed do Canal',
  mark_all_as_read_button: 'Marcar Como Lido',
  view_all_message_button: 'Visualizar todas as Mensagens',
  channel_feed_empty_text: 'Voc\u00ea est\u00e1 pronto!',
};
